import React from 'react'

import { Form, Col } from '_zari/core'

const FlagResumenFormGroup = ({ text, value, handleChange }) => {
  return (
    <Form.Group>
      <Col md={3} />
      <Col md={9}>
        <Form.Checkbox id={`checkbox-${text}`} name={`check-box${text}`} label={text} value={value} checked={value} onChange={handleChange} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagResumenFormGroup)
